<template>
    <div id="app" v-cloak>
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        name:'app',
        created(){
            if (sessionStorage.getItem('store')) {
                this.$store.replaceState(
                    Object.assign(
                        {},
                        this.$store.state,
                        JSON.parse(sessionStorage.getItem('store'))
                    )
                )
            }
            window.addEventListener('beforeunload', () => {
                sessionStorage.setItem('store', JSON.stringify(this.$store.state))
            })
        },
        methods:{
           
        }
    }
</script>

<style>
*{
    padding:0;
    margin:0;
}
html,body{
    height:100%;
    width:100%;
    box-sizing: border-box;
}
.flex{
    display: flex;
}
html,body,.el-textarea__inner{
    font-family: Avenir,Helvetica,Arial,sans-serif !important;
}
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        height: 100%;
    }
    .el-button--primary{
        background-color:#0e4ddf !important;
        border-color:#0e4ddf !important;
    }
    .el-input-number .el-input__inner{
        text-align:left;
    }
</style>
